module.exports = __webpack_public_path__ + "img/看護婦.2fac8992.png";